module.exports = __webpack_public_path__ + "static/media/branding-img15.965f33f4.jpg";